import { render, staticRenderFns } from "./approvalWarning.vue?vue&type=template&id=07043cec&scoped=true"
import script from "./approvalWarning.vue?vue&type=script&lang=js"
export * from "./approvalWarning.vue?vue&type=script&lang=js"
import style0 from "./approvalWarning.vue?vue&type=style&index=0&id=07043cec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07043cec",
  null
  
)

export default component.exports